import { useContext } from 'react'

import { filter, map, size } from 'lodash'

import CoverImage from 'Root/App/CoverImage'
import { Context as StateContext } from 'Root/App/Quiz/StateContext'
import {
  isEssayCompletedWithSuccess,
  isMatchingCompletedWithSuccess,
  isMissingWordCompletedWithSuccess,
  isMultipleChoiceCompletedWithSuccess,
  isNumericalCompletedWithSuccess,
  isSingleChoiceCompletedWithSuccess,
  isTrueFalseCompletedWithSuccess,
} from 'Root/App/Quiz/utilities'

import Failure from './Failure'
import Success from './Success'

const Feedback = ({ content, completed = false, success = false }) => {
  const { state } = useContext(StateContext)
  let correctPoints = 0

  const correctAnswers = filter(
    map(state.questions, (question) => {
      switch (question.__typename) {
        case 'QuizContentQuestionEssay':
          if (!!completed) {
            return isEssayCompletedWithSuccess(question, content)
          }
          return false
        case 'QuizContentQuestionMatching':
          return isMatchingCompletedWithSuccess(
            state.content,
            question,
            state.answers?.[question.id]
          )
        case 'QuizContentQuestionMissingWord':
          return isMissingWordCompletedWithSuccess(
            question,
            state.answers?.[question.id]
          )
        case 'QuizContentQuestionMultipleChoice':
          return isMultipleChoiceCompletedWithSuccess(
            question,
            state.answers?.[question.id]
          )
        case 'QuizContentQuestionNumerical':
          return isNumericalCompletedWithSuccess(
            question,
            state.answers?.[question.id]
          )
        case 'QuizContentQuestionSingleChoice':
          return isSingleChoiceCompletedWithSuccess(
            question,
            state.answers?.[question.id]
          )
        case 'QuizContentQuestionTrueFalse':
          return isTrueFalseCompletedWithSuccess(
            question,
            state.answers?.[question.id]
          )
      }

      return false
    })
  )

  // const points = JSON.parse(content.session?.points ?? JSON.stringify({}))
  // immediate completion can show feedback
  // only if there's no separate evaluation
  if (Boolean(content.separateEvaluation) && !completed) {
    return (
      <div className="p-4 text-blue-800 bg-blue-50 rounded-md">
        Grazie per la tua partecipazione.
      </div>
    )
  }

  correctPoints = size(correctAnswers)

  return (
    <div>
      {success ? (
        <Success>
          <p>
            Risposte corrette {correctPoints}/
            {content.basket ?? size(content.questions)}
          </p>
          <p>{content.quizFeedbackSuccessMessage || 'Quiz superato!'}</p>
          {Boolean(content.quizFeedbackSuccessImage) && (
            <CoverImage imageUrl={content.quizFeedbackSuccessImage} />
          )}
        </Success>
      ) : (
        <Failure>
          <p>
            Risposte corrette {size(correctAnswers)}/
            {content.basket ?? size(content.questions)}
          </p>
          <p>{content.quizFeedbackFailureMessage || 'Quiz non superato'}</p>
          {Boolean(content.quizFeedbackFailureImage) && (
            <CoverImage imageUrl={content.quizFeedbackFailureImage} />
          )}
        </Failure>
      )}
    </div>
  )
}

export default Feedback
